import styled from "@emotion/styled"
import { AnimatePresence } from "framer-motion"
import { DARKER_GREY_COLOR, DARK_BLUE_COLOR } from "theme/colors"
import { HEADER_Z_INDEX } from "theme/consts"
import { PX14, PX16 } from "theme/sizes"
import { BOX_SHADOW } from "theme/styles"
import Button from "ui/Button"
import Group from "ui/Group"
import { TbSparkles } from "@react-icons/all-files/tb/TbSparkles"
import { FaTimes } from "@react-icons/all-files/fa/FaTimes"
import { css } from "@emotion/react"
import Stack from "ui/Stack"

const HomeModalButtonBackground = styled(Group)<{ positionSelf: boolean }>`
  ${({ positionSelf }) =>
    positionSelf
      ? css`
          position: fixed;
          bottom: 20px;
          right: 90px;
        `
      : css`
          position: relative;
        `}
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  cursor: pointer;
  z-index: ${HEADER_Z_INDEX};
  height: 54px;
  border-radius: 8px;
  border: 1px solid ${DARK_BLUE_COLOR};
  background-color: #bcf5ff;
  box-shadow: inset 0px -5px 0px 0px #7ecad9;
`

const IconContainer = styled.div`
  height: 54px;
  width: 54px;
  min-height: 54px;
  min-width: 54px;
  flex-shrink: 0;
  flex-grow: 0;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #97e9f8;
  border-radius: 9px 0 0 9px;
  box-shadow: inset 0px -5px 0px 0px #7ecad9;
`

const CloseTriggerButton = styled(Button)`
  position: absolute;
  background-color: ${DARK_BLUE_COLOR};
  border-radius: 50px;
  color: white;
  top: -8px;
  right: -8px;
  height: 24px;
  width: 24px;
  padding: 0;
`

const ButtonBodyContent = styled(Stack)`
  padding: 0 5px;
  box-sizing: border-box;

  padding-right: 20px;
  padding-left: 20px;
`

const HomeModalButtonIcon = styled.img`
  width: 90px;
  height: 90px;
  top: -25px;
  left: -20px;
  z-index: 1;
  position: absolute;
`

type Props = {
  onClose: () => void
  onClick?: () => void
  children: React.ReactNode
  positionSelf?: boolean
  style?: React.CSSProperties
}

export default function HomeModalButton({
  onClose,
  onClick,
  children,
  style,
  positionSelf = true,
}: Props) {
  return (
    <HomeModalButtonBackground
      positionSelf={positionSelf}
      align="center"
      justify="flex-start"
      style={style}
      onClick={onClick}
    >
      <IconContainer>
        <HomeModalButtonIcon src="/icons/newsflash.png" />
      </IconContainer>
      <ButtonBodyContent align="center" justify="center">
        {children}
      </ButtonBodyContent>
      <CloseTriggerButton
        onClick={async (e) => {
          e.preventDefault()
          e.stopPropagation()
          onClose()
        }}
      >
        <FaTimes size={14} />
      </CloseTriggerButton>
    </HomeModalButtonBackground>
  )
}
